import KNB from '@dp/knb';

export const DP_PLATFORM_TYPE = '1';
export const MT_PLATFORM_TYPE = '2';


export const DP_PLATFORM_COLOR = '#f63';
export const MT_PLATFORM_COLOR = '#06c1ae';

export const {
    appName, appVersion, osName, osVersion
} = KNB.uaInfo();



// WEBPACK FOOTER //
// ./src/lib/uaInfo.js